import type { HomeStoryChapter } from "../home-story-data";

type HomeStoryRailProps = {
  chapters: HomeStoryChapter[];
  active: number;
  onSelect: (chapter: HomeStoryChapter) => void;
};

/** 章节是编辑器里真实的创作顺序，所以用有序的步骤导轨表达。 */
export function HomeStoryRail({ chapters, active, onSelect }: HomeStoryRailProps) {
  return (
    <nav className="home-story-rail" aria-label="创作步骤">
      <ol>
        {chapters.map((chapter, index) => {
          const step = index + 1;
          const state = active === step ? "is-active" : active > step ? "is-done" : "";
          return (
            <li key={chapter.id}>
              <button type="button" className={state} aria-current={active === step ? "step" : undefined} onClick={() => onSelect(chapter)}>
                <i aria-hidden="true" />
                <span>{chapter.title}</span>
                <b>{chapter.number.padStart(2, "0")}</b>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
